const selectStyle = {
  option: (styles, state) => {
    const inactive = state?.data?.inactive;
    return {
      ...styles,
      color: inactive ? "#dc3545" : (state.isSelected ? "#1f2937" : "#374151"),
      backgroundColor: state.isSelected
        ? "rgba(0, 117, 103, 0.08)"
        : state.isFocused
          ? "#f9fafb"
          : "transparent",
      padding: "0.625rem 0.875rem",
      cursor: "pointer",
      transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
      fontSize: "0.875rem",
      whiteSpace: "normal",
      wordWrap: "break-word",
      "&:hover": !inactive && {
        color: "#1f2937",
        backgroundColor: "rgba(0, 117, 103, 0.08)",
      },
      "&:active": {
        backgroundColor: "rgba(0, 117, 103, 0.12)",
      },
    };
  },
  singleValue: (styles, state) => {
    const inactive = state?.data?.inactive;
    return {
      ...styles,
      color: state.isDisabled ? "#6c757d" : inactive ? "#dc3545" : "#1f2937",
      fontSize: "0.875rem",
      fontWeight: 400,
    };
  },
  control: (styles, state) => ({
    ...styles,
    minHeight: "38px",
    backgroundColor: state.isDisabled ? "#e9ecef" : "#ffffff",
    borderWidth: "1.5px",
    borderColor: state.isDisabled ? "#ced4da" : state.isFocused ? "#28f0d8" : "#d1d5db",
    borderRadius: "0.5rem",
    boxShadow: state.isFocused && !state.isDisabled
      ? "0 0 0 3px rgba(40, 240, 216, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.65 : 1,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    zIndex: state.isFocused ? 2 : 1,
    "&:hover": {
      borderColor: state.isDisabled ? "#ced4da" : state.isFocused ? "#28f0d8" : "#9ca3af",
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: "0.375rem 0.875rem",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#6b7280",
    fontSize: "0.875rem",
    opacity: 0.6,
  }),
  input: (styles) => ({
    ...styles,
    margin: "0",
    padding: "0",
    color: "#1f2937",
    fontSize: "0.875rem",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    backgroundColor: "#d1d5db",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#007567" : "#6b7280",
    padding: "0.5rem",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#007567",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#6b7280",
    padding: "0.5rem",
    "&:hover": {
      color: "#dc3545",
    },
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    marginTop: "0.25rem",
    zIndex: 9999,
  }),
  menuList: (styles) => ({
    ...styles,
    padding: "0.375rem",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};


export const customStyles = {
  option: (styles, state) => {
    const isDisabled = state?.isDisabled;

    return {
      ...styles,
      color: isDisabled
        ? "#6c757d"
        : (state.isSelected ? "#1f2937" : "#374151"),
      backgroundColor: isDisabled
        ? "#f3f4f6"
        : (state.isSelected ? "rgba(0, 117, 103, 0.08)" : "transparent"),
      padding: "0.625rem 0.875rem",
      cursor: isDisabled ? "not-allowed" : "pointer",
      transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
      fontSize: "0.875rem",
      whiteSpace: "normal",
      wordWrap: "break-word",
      "&:hover": !isDisabled && {
        color: "#1f2937",
        backgroundColor: "rgba(0, 117, 103, 0.08)",
      },
      "&:active": {
        backgroundColor: "rgba(0, 117, 103, 0.12)",
      },
    };
  },
  control: (styles, state) => ({
    ...styles,
    minHeight: "38px",
    backgroundColor: state.isDisabled ? "#e9ecef" : "#ffffff",
    borderWidth: "1.5px",
    borderColor: state.isDisabled ? "#ced4da" : state.isFocused ? "#28f0d8" : "#d1d5db",
    borderRadius: "0.5rem",
    boxShadow: state.isFocused && !state.isDisabled
      ? "0 0 0 3px rgba(40, 240, 216, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.65 : 1,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      borderColor: state.isDisabled ? "#ced4da" : state.isFocused ? "#28f0d8" : "#9ca3af",
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: "0.375rem 0.875rem",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#6b7280",
    fontSize: "0.875rem",
    opacity: 0.6,
  }),
  input: (styles) => ({
    ...styles,
    margin: "0",
    padding: "0",
    color: "#1f2937",
    fontSize: "0.875rem",
  }),
  singleValue: (styles, state) => ({
    ...styles,
    color: state.isDisabled ? "#6c757d" : "#1f2937",
    fontSize: "0.875rem",
    fontWeight: 400,
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    backgroundColor: "#d1d5db",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#007567" : "#6b7280",
    padding: "0.5rem",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#007567",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#6b7280",
    padding: "0.5rem",
    "&:hover": {
      color: "#dc3545",
    },
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    marginTop: "0.25rem",
    zIndex: 9999,
  }),
  menuList: (styles) => ({
    ...styles,
    padding: "0.375rem",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};



export const errorSelectStyle = {
  ...customStyles,
  control: (styles, state) => ({
    ...customStyles.control(styles, state),
    borderColor: "#dc3545",
    boxShadow: state.isFocused
      ? "0 0 0 3px rgba(220, 53, 69, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "&:hover": {
      borderColor: "#dc3545",
    },
  }),
};


export const uomStyle = {
  ...customStyles,
  control: (...props) => ({
    ...customStyles.control(...props),
    minHeight: '31px',
    height: '31px',
    borderRadius:"6px"
  }),
  menu:(base)=>({...base,width:300}),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '27px',
    padding: '0px 6px',
    marginBottom: '4px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  indicatorSeparator: state => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '27px',
    marginBottom: '4px'

  }),
};


export const compactSelect = {
  option: (styles, state) => {
    const inactive = state?.data?.inactive;
    const isDisabled = state?.data?.isDisabled;

    return {
      ...styles,
      color: isDisabled
        ? "#6c757d"
        : inactive
          ? "#dc3545"
          : (state.isSelected ? "#1f2937" : "#374151"),
      backgroundColor: isDisabled
        ? "#f3f4f6"
        : (state.isSelected ? "rgba(0, 117, 103, 0.08)" : "transparent"),
      padding: "0.5rem 0.75rem",
      cursor: isDisabled ? "not-allowed" : "pointer",
      fontSize: "0.8125rem",
      transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
      whiteSpace: "normal",
      wordWrap: "break-word",
      "&:hover": !inactive && !isDisabled && {
        color: "#1f2937",
        backgroundColor: "rgba(0, 117, 103, 0.08)",
      },
    };
  },
  singleValue: (styles, state) => {
    const inactive = state?.data?.inactive;
    return {
      ...styles,
      color: state.isDisabled ? "#6c757d" : inactive ? "#dc3545" : "#1f2937",
      fontSize: "0.8125rem",
      fontWeight: 400,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };
  },
  control: (styles, state) => ({
    ...styles,
    minHeight: "34px",
    maxHeight: "34px",
    backgroundColor: state.isDisabled ? "#e9ecef" : "#ffffff",
    borderWidth: "1.5px",
    borderColor: state.isDisabled ? "#ced4da" : state.isFocused ? "#28f0d8" : "#d1d5db",
    borderRadius: "0.375rem",
    boxShadow: state.isFocused && !state.isDisabled
      ? "0 0 0 3px rgba(40, 240, 216, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    fontSize: "0.8125rem",
    marginBottom: "0",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.65 : 1,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      borderColor: state.isDisabled ? "#ced4da" : state.isFocused ? "#28f0d8" : "#9ca3af",
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: "2px 0.625rem",
    height: "31px",
    minHeight: "31px",
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#6b7280",
    fontSize: "0.8125rem",
    opacity: 0.6,
    margin: 0,
  }),
  input: (styles) => ({
    ...styles,
    margin: "0",
    padding: "0",
    fontSize: "0.8125rem",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#007567" : "#6b7280",
    padding: "4px",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#007567",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    padding: "4px",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    height: "31px",
    minHeight: "31px",
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: "0.375rem",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    marginTop: "0.25rem",
    zIndex: 9999,
  }),
  menuList: (styles) => ({
    ...styles,
    padding: "0.25rem",
  }),
};

export const compactSelectError = {
  ...compactSelect,
  control: (styles, state) => ({
    ...compactSelect.control(styles, state),
    borderColor: "#dc3545",
    boxShadow: state.isFocused
      ? "0 0 0 3px rgba(220, 53, 69, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "&:hover": {
      borderColor: "#dc3545",
    },
  }),
};

export const multiSelectHeaderStyle = {
  ...selectStyle,
  container: (base) => ({
    ...base,
    width: 'auto',
    minWidth: '100px',
    maxWidth: '110px',
    fontSize: '13px'
  }),
  control: (base, state) => ({
    ...selectStyle.control(base, state),
    minHeight: '32px',
    padding: '0 2px'
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '2px 6px'
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: '13px'
  }),
  input: (base) => ({
    ...base,
    fontSize: '13px'
  }),
  menu: (base) => ({
    ...base,
    fontSize: '13px',
    minWidth: '150px',
    maxWidth: '300px',
  }),
  option: (base, state) => ({
    ...selectStyle.option(base, state),
    fontSize: '13px',
    padding: '8px 12px'
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: '0'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '4px 2px'
  })
};

export const modernSelectStyle = {
  option: (styles, state) => ({
    ...styles,
    color: state.isSelected ? "#007567" : "#1f2937",
    backgroundColor: state.isSelected
      ? "rgba(0, 117, 103, 0.08)"
      : state.isFocused
        ? "#f9fafb"
        : "transparent",
    padding: "0.625rem 0.875rem",
    fontSize: "0.875rem",
    cursor: "pointer",
    transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
    whiteSpace: "normal",
    wordWrap: "break-word",
    "&:active": {
      backgroundColor: "rgba(0, 117, 103, 0.12)",
    },
  }),
  control: (styles, state) => ({
    ...styles,
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    minHeight: "38px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      border: "none",
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: "0",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#1f2937",
    fontSize: "0.875rem",
    fontWeight: 500,
  }),
  placeholder: (styles) => ({
    ...styles,
    color: "#6b7280",
    fontSize: "0.875rem",
    opacity: 0.6,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#007567" : "#6b7280",
    padding: "0 0.25rem",
    transition: "all 0.2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0)",
    "&:hover": {
      color: "#007567",
    },
  }),
  menu: (styles) => ({
    ...styles,
    backgroundColor: "#ffffff",
    borderRadius: "0.75rem",
    boxShadow: "0 20px 50px -12px rgba(0, 0, 0, 0.15)",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    zIndex: 9999,
    marginTop: "0.25rem",
  }),
  menuList: (styles) => ({
    ...styles,
    padding: "0.375rem",
  }),
  input: (styles) => ({
    ...styles,
    fontSize: "0.875rem",
    color: "#1f2937",
  }),
};

export default selectStyle;